import { useQuery } from '@tanstack/react-query';
import { getComponentAiSummary } from '../../../../../../core/api';

export const useGetComponentAiSummary = (
  courseId,
  assignmentId,
  responsesComponentId,
  isEnabled
) => {
  const {
    data: surveyResultsSummaryData,
    isLoading: isLoadingAiSummary,
  } = useQuery({
    queryKey: [
      'componentAiSummary',
      courseId,
      assignmentId,
      responsesComponentId,
    ],
    queryFn: () =>
      getComponentAiSummary(courseId, assignmentId, responsesComponentId),
    enabled: isEnabled,
  });

  return { surveyResultsSummaryData, isLoadingAiSummary };
};
